import React from "react";
import styled from "styled-components";

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100vh;
  border: none;
`;

const BrainHealthProject: React.FC = () => {
  return (
    <StyledIframe src="https://centerforbrainhealth.org/science/the-brainhealth-project" />
  );
};

export default BrainHealthProject;
